// extracted by mini-css-extract-plugin
export var loadingErrorViewError = "loading-error-view__error_rOu9uOJRTihlYrHGqQAN";
export var loadingErrorViewErrorSubtitle = "loading-error-view__error-subtitle_mvsMTtrgP99y9n5534j6";
export var loadingErrorViewErrorTitle = "loading-error-view__error-title_GvcdUI2Oi1utSURk_wWg";